// extracted by mini-css-extract-plugin
export default {"breadcrumb_link":"e394eZgfxodDN_P28n8t","breadcrumb_span":"VPZNenUPY1t_UObqycAM","chevron_right":"Er_Sa_l3S9VOsik59Uf5"};